import { useState } from "react";
import { Settings, User, CircleHelp, Megaphone, ChevronsUpDown } from "lucide-react";
import { cn } from "@/shared/lib/utils";

const MENU_ITEMS = [
	{ label: "Settings", icon: Settings },
	{ label: "Support", icon: User },
	{ label: "FAQ", icon: CircleHelp },
];

export function ProfileMenuDemo() {
	const [open, setOpen] = useState(false);
	const [clicked, setClicked] = useState<string | null>(null);

	const handleItemClick = (label: string) => {
		setClicked(label);
		setTimeout(() => { setClicked(null); setOpen(false); }, 600);
	};

	return (
		<div className="not-prose flex flex-col items-center gap-4 rounded-lg border bg-muted/30 p-5">
			<div className="relative w-[200px]">
				{/* Popover */}
				{open && (
					<div className="absolute bottom-full left-0 w-[184px] mb-1 rounded-md border border-sidebar-border bg-sidebar text-sidebar-foreground shadow-md z-10 overflow-hidden">
						<div className="px-3 py-2 border-b border-sidebar-border flex items-center justify-between">
							<span className="text-xs text-sidebar-foreground/60 truncate">jane.doe@firm.com</span>
							<button
								type="button"
								onClick={() => handleItemClick("What's New")}
								className="flex items-center justify-center p-1 rounded-sm hover:bg-sidebar-accent transition-colors"
								title="What's New"
							>
								<Megaphone className={cn("size-4 text-sidebar-foreground/60 hover:text-sidebar-foreground", clicked === "What's New" && "text-primary")} />
							</button>
						</div>
						<div className="pt-1 pb-0.5">
							{MENU_ITEMS.map(({ label, icon: Icon }) => (
								<button
									key={label}
									type="button"
									onClick={() => handleItemClick(label)}
									className={cn(
										"flex w-full items-center gap-2 px-3 py-2 text-sm rounded-sm transition-colors",
										clicked === label
											? "bg-sidebar-accent text-sidebar-accent-foreground font-medium"
											: "hover:bg-sidebar-accent",
									)}
								>
									<Icon className="size-4" />
									<span>{label}</span>
								</button>
							))}
						</div>
					</div>
				)}

				{/* Profile trigger — matches SidebarMenuButton size="lg" */}
				<button
					type="button"
					onClick={() => setOpen(!open)}
					className="flex w-full items-center gap-2 rounded-md py-2.5 px-3 hover:bg-sidebar-accent transition-colors cursor-pointer bg-sidebar text-sidebar-foreground border border-sidebar-border"
				>
					<div className="flex h-7 w-7 items-center justify-center rounded-full bg-sidebar-primary text-sidebar-primary-foreground text-xs font-medium shrink-0">
						JD
					</div>
					<div className="flex-1 text-left leading-tight min-w-0">
						<span className="text-sm font-medium block truncate">Jane Doe</span>
						<span className="text-xs text-sidebar-foreground/50 block truncate">Attorney</span>
					</div>
					<ChevronsUpDown className="size-4 text-sidebar-foreground/50 shrink-0" />
				</button>
			</div>

			<p className="text-center text-[11px] text-muted-foreground">
				Click the profile to open the menu
			</p>
		</div>
	);
}
